import template from './adpComponentCategory.html';
import controller from './adpComponentCategory.controller';
import './adpComponentCategory.less';

let adpComponentCategoryComponent = {
  restrict: 'E',
  bindings: {},
  template,
  transclude: true,
  controller
};

export default adpComponentCategoryComponent;



// WEBPACK FOOTER //
// ./src/app/components/adpComponentCategory/adpComponentCategory.component.js